import router from "@/_evoli/router"

function retry(store, method, callback, retries = 0) {
  if (retries >= 5) return

  const loading = store.rootGetters.checkLoading("SOCKET", method)
  if (loading) {
    callback()
    setTimeout(() => {
      retry(store, method, callback, retries + 1)
    }, 600)
  }
}

export default {
  SEND_route(store, payload) {
    socketSend(this, store, {
      type: "route",
      route: payload.path,
      entityName: payload.meta?.entityName
    })
  },
  SEND_openUserDashboard(store) {
    socketSend(this, store, { type: "openUserDashboard" })
  },
  SEND_closeUserDashboard(store) {
    socketSend(this, store, { type: "closeUserDashboard" })
  },
  SEND_lists(store, payload) {
    const lists = payload.route.meta.lists || []
    let filter = payload.filter

    lists.forEach((list) => {
      filter = {
        ...filter,
        ...store.rootGetters.getFilterList(list)
      }
    })

    Object.keys(filter).forEach((key) => {
      if (!filter[key] || filter[key] === "") delete filter[key]
    })

    const signature = JSON.stringify({
      lists: lists.map((l) => l.name),
      filter,
      archiv: payload.archiv
    })

    if (store.state.lastListsPayload === signature) return
    store.commit("setLastListsPayload", signature)

    socketSend(this, store, {
      type: "lists",
      lists,
      filter,
      archiv: payload.archiv
    })
    if (lists.length > 0) {
      lists.forEach((list) => {
        store.commit(
          "addLoading",
          {
            skeleton: false,
            method: "SOCKET",
            route: "lists_" + list.name
          },
          { root: true }
        )

        setTimeout(() => {
          retry(store, "lists_" + list.name, () => {
            socketSend(this, store, {
              type: "lists",
              lists,
              filter,
              archiv: payload.archiv
            })
          })
        }, 1000)
      })
    }
  },
  SEND_ticket(store, payload) {
    socketSend(this, store, {
      type: "ticket",
      ticket: payload
    })
  },
  SEND_anonStatus(store, waitForFile) {
    const route = router.currentRoute?.path
    if (!route) return

    socketSend(this, store, {
      type: "anonStatus",
      route,
      waitForFile
    })
  },
  SEND_activ(store, payload) {
    socketSend(this, store, {
      type: "activ",
      ...payload
    })
  },
  SEND_save(store, payload) {
    socketSend(this, store, {
      type: "save",
      ...payload.meta
    })
  },
  SEND_motd(store) {
    socketSend(this, store, {
      type: "motd"
    })
  },
  SEND_analyzeProgress(store, payload) {
    socketSend(this, store, {
      type: "analyzeProgress",
      ...payload
    })
  },
  SEND_correctionProgress(store, waitForStart) {
    socketSend(this, store, {
      type: "correctionProgress",
      waitForStart
    })
  },

  RECIEVE_openBy(store, payload) {
    store.commit("setOpenBy", payload)
  },
  RECIEVE_openByAll(store, payload) {
    Object.keys(payload.openBy).forEach((route) => {
      store.commit("setOpenBy", {
        route,
        openBy: payload.openBy[route]
      })
    })
  },
  RECIEVE_count(store, payload) {
    store.commit("setCount", payload)
    store.commit(
      "removeLoading",
      {
        skeleton: false,
        method: "SOCKET",
        route: "lists_" + payload.list
      },
      { root: true }
    )
  },
  RECIEVE_ticket(store, { ticket }) {
    store.commit("tickets/addTicket", ticket, { root: true })
  },
  RECIEVE_userDashboard(store, { dashboard }) {
    store.commit("setUserDashboard", { dashboard })
  },
  RECIEVE_anonStatus(store, payload) {
    store.commit("setAnonStatus", payload)
  },
  RECIEVE_motd(store) {
    store.dispatch("READ_Motd", null, { root: true })
  },
  RECIEVE_analyzeProgress(store, payload) {
    store.commit("setAnalyzeProgress", payload)
  },
  RECIEVE_correctionProgress(store, payload) {
    store.commit("setCorrectionProgress", payload)
  }
}

function socketSend(self, store, payload, retries = 0) {
  const accessToken = store.rootGetters.getAccessToken

  if (!self.$socket || self.$socket.readyState !== 1) {
    if (retries >= 5) return
    setTimeout(() => {
      socketSend(self, store, payload, retries + 1)
    }, 300)
    return
  }

  self.$socket.send(
    JSON.stringify({
      ...payload,
      accessToken
    })
  )
}
